var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    enableBackground: "new 0 0 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FLOOR"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_83_",
    fill: "#E3F0FF",
    cx: 311.3,
    cy: 499.7,
    rx: 171.7,
    ry: 8.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "FIRE_3A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    fill: "#FF8D76",
    d: "M386.5,497.9c0,0-3.3-5.6,3.8-8.3c7.1-2.7,23.2-4.4,21.6-9.9c-1.6-5.5-7.1-15.4,6.7-24.8 c13.7-9.3,11-13.3,12.9-12.4s6.5,6.4,5.7,11.6c-0.8,5.2-4.6,6.5-2.8,8.2c1.8,1.6,7.9-4.3,7.9-9.8s0.3-9.5,4.3-7.2 c3.9,2.3,3.4,5.6,6.2,3.1c2.8-2.5,4.6-7.5,3.4-14.9c-1.1-7.4,2.5-12.9,7.7-13.1c5.2-0.2,16,9.5,16.9,24.2c0.8,14.7-8.3,26.7-7,30.4 c1.3,3.8,7,2,10-3.4c2.9-5.4,10.1,3.1,8.2,10.5c-2,7.4-3.8,15.5-8.2,17c-4.4,1.5-82.5,0.3-88.4,0.3 C389.4,499.4,387.6,499.5,386.5,497.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "FIRE_3B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    fill: "#FEC272",
    d: "M405,495.4c4.1-0.1,16.4,0,14.9-6.9c-1.5-6.9-4.1-9.8,0.2-15.7c4.3-5.9,9-2.3,9.2,0.7 c0.2,2.9-1,8.8,4.1,8c5.1-0.8,5.2-14.6,9.5-15.7c4.3-1.1,5.6,3.1,6.2,7.2c0.7,4.1,5.7-0.3,7.7-5.2c2-4.9,1.8-11.6,6.4-13.6 c4.6-2,6.9,9.5,4.9,20c-2,10.5-3.6,15.7-1.1,16.7s7.4-1.5,9.7,2.3c2.3,3.8-1.1,6.4-10.5,6.4c-9.3,0-57,0-64.5,0 C394,499.5,395.6,495.6,405,495.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "FIRE_2A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    fill: "#FEC272",
    d: "M132.8,336.4c-3,5.3-11.1,2.6-14.9-3.4c-3.8-6.1-9.5-2.5-8.2,9.5 c1.3,11.9,6.1,19.8,14.7,25.5s18.3,8,16,11.9c-2.3,3.9-5.9,12.8,7,17.3c12.9,4.6,31.6,2.5,41.2-8.3c9.7-10.8,9.7-34.6,5.2-47.4 c-4.4-12.8-13.3-20.9-16.2-26.8c-2.9-5.9-8.3-1.8-7.4,3.7c1,5.5,2.8,8.7-1.1,8.8c-3.9,0.1-6.5-13.3-18.2-15.8 c-11.7-2.6-13.6,4.4-21,0.4c-7.4-4.1-10.1-3.7-10.6,2.7c-0.5,6.5,4.4,13.6,8.6,14.7C134.2,330.8,134.8,332.8,132.8,336.4z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "FIRE_2B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    fill: "#FF8D76",
    d: "M150,342.6c1.1,5.7-3.6,11.9-11.8,8.3c-8.2-3.6-11.1-0.7-6.9,6.9s13.6,14.6,18.7,17.2 c5.1,2.6,1.6,6.4,2.3,10.3c0.7,3.9,12.1,9.8,23.6-2.8c11.5-12.6,11.6-28.6,8.3-40.3c-3.3-11.6-7.7-9.8-7.7-5.9s0.5,11.6-2.5,10.8 c-2.9-0.8-7-6.5-10.8-13.1c-6.5-11.3-22.4-20.5-24.5-11.8C137.2,328.3,148.4,333.9,150,342.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "FIRE_1A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    fill: "#FEC272",
    d: "M381.9,305.3c-14.4-11.7-27.5-32.7-30.4-70.4c-2.1-27.3,7-39.4,16.4-43.9 c9.3-4.4,9.3-8.8,13.5-7.6c4.2,1.2,3.2,10.8-0.7,15.5c-3.9,4.7-4.4,12,1.5,12.5c5.9,0.5,6.6-10.1,7.6-19.9c1-9.8,3.4-13.7,15-19.1 s17.7-9.3,20.1-17.2c2.5-7.9,4.9-7.4,9.3-5.2c4.4,2.2,5.9,12.5,2.2,16.4c-3.7,3.9-6.6,6.9-6.1,10.3c0.5,3.4,2.2-2,12.3-6.9 c10.1-4.9,14.2-19.6,15.5-27.2s3.9-9.6,11-6.1c7.1,3.4,16.2,16.9,13.7,35.3c-2.5,18.4-15,30.9-16.9,40.8c-2,9.8,4.2,12,10.6,8.3 c6.4-3.7,2.9-14.7,6.4-19.9c3.4-5.2,14,5.9,17.2,24.5s8.1,48.2-19.6,75.9C451.9,329.8,410,328.2,381.9,305.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "FIRE_1B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    fill: "#FF8D76",
    d: "M392.6,218c7-11.4,14.2-11,14.5-6.9c0.2,4.2-5.6,10.1-2.7,13s6.9-2.2,8.1-9.6 s8.3-11.5,15.7-15c7.4-3.4,10.6-10.8,14.2-11s4.9,7.6,2.5,12.3c-2.5,4.7-11.3,7.1-11.3,13.7s6.5,7,9.3,1.5s2.1-8.5,8-9 c5.9-0.5,5.4,13.6,1.5,18.8s-10.6,9.3-7.5,14.4s8.8,0,11.9-3.4c3.1-3.4,9.3,0.3,10.3,6.9c1,6.5-11.8,17.7-11,23.4 c0.8,5.7,5.9,4.3,8.8,0.3c2.9-3.9,6.7,1.1,5.7,7.7s-18.8,28.5-50.6,20.1C373.8,283.1,380.1,238.5,392.6,218z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ANTENNA_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    fill: "#E1ECFF",
    d: "M226.4,204.4L330,114.1c1-0.9,2.5-0.8,3.4,0.2v0c0.9,1,0.8,2.6-0.2,3.5L231.3,211 L226.4,204.4z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "ANTENNA_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    fill: "#E1ECFF",
    d: "M216.7,222.8L159.9,97.6c-0.6-1.2,0-2.7,1.2-3.2h0c1.2-0.6,2.7-0.1,3.3,1.2l60,124.5 L216.7,222.8z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "TV"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_171_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_59_",
    fill: "#0D2560",
    cx: 217.3,
    cy: 214,
    r: 18.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_190_",
    fill: "#273D7A",
    cx: 216.5,
    cy: 202.3,
    rx: 9,
    ry: 5.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_94_",
    fill: "#1C3177",
    d: "M364.5,444.4c-0.3,8.5-10.2,8.8-15.1-1c-2.3-4.7-6.1-12.7-9.4-19.7 c-3.6-7.7-6.6-14.3-6.6-14.3l28.5,2.9c0,0,0.6,5,1.3,11.3C364,430.8,364.7,439.8,364.5,444.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    fill: "#072359",
    d: "M363.2,423.6c-1.4,0.3-3,0.6-4.7,0.9c-5.9,1-12.7,0.3-18.4-0.8 c-3.6-7.7-6.6-14.3-6.6-14.3l28.5,2.9C361.9,412.3,362.6,417.3,363.2,423.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    fill: "#1C3177",
    d: "M171.2,411.8c-3,8,5.9,12.1,14.2,5c4-3.4,10.6-9.3,16.4-14.5c6.3-5.7,11.7-10.6,11.7-10.6 l-27.4-8.5c0,0-2.5,4.4-5.6,9.9C177.1,399.6,172.8,407.5,171.2,411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    fill: "#072359",
    d: "M180.6,393.2c1.2,0.9,2.5,1.8,4,2.7c5,3.2,11.5,5.2,17.3,6.5c6.3-5.7,11.7-10.6,11.7-10.6 l-27.4-8.5C186.2,383.3,183.7,387.7,180.6,393.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    fill: "#0D2560",
    d: "M437.2,304c-3.8,29.9-7.2,61.6-13.7,83.5c-0.8,2.8-1.7,5.4-2.7,7.8 c-8.3,21.6-23.4,17.2-42.9,19c-19.5,1.8-25.4,1.6-25.4,1.6l5-30.4l23.8-143.6L428,246c0,0,2.5,1.8,4.6,5.2 C434.8,254.7,441.5,270.2,437.2,304z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    fill: "#072359",
    d: "M423.5,387.5c-0.8,2.8-1.7,5.4-2.7,7.8c-8.3,21.6-23.4,17.2-42.9,19 c-19.5,1.8-25.4,1.6-25.4,1.6l5-30.4L423.5,387.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    fill: "#142966",
    d: "M179.5,220.6c0,0,12.2-6.4,26-6.9s123,10.4,158.7,14.3c35.7,3.9,51.1,8.8,58.3,12.6 s10.1,10.6,10.1,10.6l-57.3-5.2L179.5,220.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    fill: "#273D7A",
    d: "M157.7,353.1l7.3-112.6c0.8-13,12.4-22.7,25.3-21.2l185.6,21c11.6,1.3,19.9,11.7,18.8,23.2 l-12.2,122.9c-1.9,18.9-19.4,32.2-38.1,29.1l-158.7-26.9C168.7,385.7,156.6,370.3,157.7,353.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    fill: "#FEC272",
    d: "M331.5,390.2l13.4-129.9c0.6-5.5,5.5-9.5,11-8.9l23.3,2.6c5.5,0.6,9.4,5.6,8.8,11l-15,130 c-0.6,5.5-5.7,9.4-11.2,8.7l-21.6-2.7C334.8,400.4,330.9,395.6,331.5,390.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_174_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_188_",
    fill: "#F9A95A",
    d: "M382.1,279.7c0,4.2-1.5,8-3.9,11c-1.7,2-3.7,3.7-6.1,4.8c-2.2,1.1-4.7,1.6-7.4,1.6 c-9.6,0-17.4-7.8-17.4-17.4c0-4,1.4-7.7,3.6-10.6c1.6-2.1,3.6-3.8,6-5c2.3-1.2,5-1.8,7.8-1.8 C374.2,262.3,382.1,270.1,382.1,279.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    fill: "#99ADF9",
    d: "M381.2,276.8c0,3.8-1.3,7.3-3.6,10.1c-1.5,1.9-3.4,3.4-5.6,4.4c-2.1,1-4.3,1.5-6.8,1.5 c-8.8,0-16-7.1-16-16c0-3.7,1.2-7,3.3-9.7c1.5-1.9,3.3-3.5,5.5-4.5c2.2-1.1,4.6-1.7,7.1-1.7C374.1,260.8,381.2,268,381.2,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    fill: "#C5DFFF",
    d: "M377.7,286.9c-1.5,1.9-3.4,3.4-5.6,4.4l-19.4-24.2c1.5-1.9,3.3-3.5,5.5-4.5L377.7,286.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_187_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_173_",
    fill: "#F9A95A",
    d: "M366.4,337.5c-3.8,1.5-7.7,1.6-11.3,0.5c-2.4-0.7-4.7-2-6.6-3.8c-1.8-1.6-3.2-3.7-4.2-6 c-3.5-8.7,0.6-18.6,9.3-22.1c3.6-1.5,7.4-1.6,10.9-0.6c2.4,0.7,4.7,1.9,6.7,3.6c1.9,1.7,3.5,3.8,4.5,6.3 C379.3,324.1,375.1,334,366.4,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    fill: "#99ADF9",
    d: "M366.4,333.4c-3.5,1.4-7.3,1.5-10.7,0.5c-2.3-0.7-4.4-1.9-6.2-3.5c-1.7-1.5-3-3.4-3.9-5.7 c-3.3-8.2,0.6-17.5,8.7-20.8c3.4-1.4,7-1.5,10.3-0.6c2.3,0.6,4.4,1.8,6.3,3.4c1.8,1.6,3.3,3.6,4.3,6 C378.5,320.8,374.6,330.1,366.4,333.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    fill: "#C5DFFF",
    d: "M370.9,306.6l-15.2,27.3c-2.3-0.7-4.4-1.9-6.2-3.5l15.1-27.1 C367,303.9,369.1,305,370.9,306.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    fill: "#0D2560",
    d: "M367,356.2l-21-3.2c-1.4-0.2-2.4-1.5-2.2-2.9l0,0c0.2-1.4,1.4-2.4,2.8-2.2l21,3.2 c1.4,0.2,2.4,1.5,2.2,2.9h0C369.6,355.4,368.3,356.4,367,356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    fill: "#0D2560",
    d: "M365.6,367.8l-21-3.2c-1.4-0.2-2.4-1.5-2.2-2.9l0,0c0.2-1.4,1.4-2.4,2.8-2.2l21,3.2 c1.4,0.2,2.4,1.5,2.2,2.9l0,0C368.3,367.1,367,368,365.6,367.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    fill: "#0D2560",
    d: "M364.3,379.5l-21-3.2c-1.4-0.2-2.4-1.5-2.2-2.9l0,0c0.2-1.4,1.4-2.4,2.8-2.2l21,3.2 c1.4,0.2,2.4,1.5,2.2,2.9l0,0C367,378.7,365.7,379.7,364.3,379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    fill: "#0D2560",
    d: "M363,391.1l-21-3.2c-1.4-0.2-2.4-1.5-2.2-2.9l0,0c0.2-1.4,1.4-2.4,2.8-2.2l21,3.2 c1.4,0.2,2.4,1.5,2.2,2.9v0C365.7,390.3,364.4,391.3,363,391.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_37_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_249_",
    fill: "#F8FBFF",
    d: "M336.4,264.1l-0.6,6.3l-10.6,111.8c-0.4,3.8-2,7.2-4.5,9.7c-3.5,3.6-8.6,5.5-14,4.6 l-119.5-18.9c-12.5-2-21.5-13.2-20.7-25.9l6.4-100.2l0.2-3.3l0.4-5.5c0.5-7.6,7.3-13.3,14.9-12.4l134,16.1 C331,247.6,337.2,255.4,336.4,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    fill: "#C5DFFF",
    d: "M336.4,264.1l-0.6,6.3l-162.7-22.1l0.4-5.5c0.5-7.6,7.3-13.3,14.9-12.4l134,16.1 C331,247.6,337.2,255.4,336.4,264.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    fill: "#FFFFFF",
    d: "M189.4,241.8c-0.3,2-2.2,3.5-4.3,3.2s-3.7-2.1-3.4-4.1c0.3-2,2.2-3.5,4.3-3.2 S189.6,239.8,189.4,241.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    fill: "#FFFFFF",
    d: "M205.2,243.7c-0.3,2-2.2,3.5-4.3,3.2s-3.7-2.1-3.4-4.1c0.3-2,2.2-3.5,4.3-3.2 S205.4,241.7,205.2,243.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    fill: "#FFFFFF",
    d: "M220.9,245.6c-0.3,2-2.2,3.5-4.3,3.2s-3.7-2.1-3.4-4.1c0.3-2,2.2-3.5,4.3-3.2 C219.7,241.7,221.2,243.6,220.9,245.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_199_",
    fill: "#E1ECFF",
    d: "M320.7,391.9c-3.5,3.6-8.6,5.5-14,4.6l-119.5-18.9c-12.5-2-21.5-13.2-20.7-25.9 l6.4-100.2c2.1,34.7-3.2,73.4,16.1,95.4C217.3,379.2,243,379,320.7,391.9z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_04"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_168_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    fill: "#99ADF9",
    d: "M224.3,289.4l-5-0.8c-1.3-0.2-2.4,0.6-2.5,1.9l-1.5,13.7l-6.3-0.7 c-1.1-0.2-1.8-1.3-1.4-2.3l4.5-11c0.6-1.4-0.4-3-1.9-3.2l-4.1-0.7c-1-0.2-2,0.4-2.4,1.3l-7.1,17.6c-0.8,2,0.5,4.3,2.7,4.7 l15.1,2.6l-2.7,24.4c-0.1,1.3,0.8,2.5,2.1,2.7l4.7,0.7c1.2,0.2,2.3-0.6,2.5-1.9l5.4-46.2C226.5,290.9,225.6,289.6,224.3,289.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_169_",
    fill: "#99ADF9",
    d: "M295.6,301.3l-5.1-0.9c-1.3-0.2-2.5,0.7-2.6,1.9l-1.6,14.2l-6.6-0.7 c-1.1-0.2-1.8-1.4-1.4-2.4l4.6-11.4c0.6-1.4-0.4-3.1-2-3.4l-4.2-0.7c-1.1-0.2-2.1,0.4-2.5,1.3l-7.4,18.2c-0.8,2.1,0.6,4.5,2.8,4.9 l15.6,2.6l-2.8,25.3c-0.1,1.3,0.8,2.6,2.2,2.8l4.9,0.7c1.3,0.2,2.4-0.7,2.6-1.9l5.6-47.9C297.9,302.7,296.9,301.5,295.6,301.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_172_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_254_",
    fill: "#99ADF9",
    d: "M248.7,292.6c-9.9-0.9-15.7,4.7-18.1,21.2c-3,20.5,2.4,28.8,12.4,31.1 c13.6,3.2,16-8.5,18.7-25.8C264.4,301.8,258.6,293.5,248.7,292.6z M253.6,318.7c-1.3,12.1-5,19-9.5,17.9 c-4.8-1.2-6.6-6.8-5.2-21.1c1.1-11.5,3.9-15.4,8.6-15C252.2,301,254.9,306.6,253.6,318.7z"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "ORNAMENT_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    fill: "#FF8D76",
    d: "M379.2,163c-4.8-0.1-6.9-11.6-2.4-14.5s7.7,3,7.8,7.3S383.5,163.2,379.2,163z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_70_",
    fill: "#FEC272",
    d: "M434.7,129.7c-4.4-0.1-6.3-10.5-2.1-13.1c4.1-2.6,6.9,2.7,7,6.6S438.6,129.8,434.7,129.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    fill: "#FF8D76",
    d: "M478.6,108.5c-4.5-0.1-6.5-10.8-2.2-13.5c4.3-2.7,7.1,2.8,7.3,6.8S482.6,108.7,478.6,108.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    fill: "#FEC272",
    d: "M515.1,191c-3.8-1-3.3-10.7,0.9-12.1c4.2-1.4,5.6,3.8,4.9,7.3S518.6,191.9,515.1,191z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "ORNAMENT_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    fill: "#FEC272",
    d: "M131.9,292.4c-4.7-0.7-5.6-12.2-0.7-14.5s7.2,3.8,6.9,8 C137.7,290.2,136.2,292.9,131.9,292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_77_",
    fill: "#FF8D76",
    d: "M118.4,255.4c-3.7-0.5-4.3-9.5-0.6-11.3s5.6,2.9,5.3,6.2 C122.9,253.7,121.7,255.9,118.4,255.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    fill: "#FEC272",
    d: "M91.3,314.8c-6-0.8-7.1-15.6-0.9-18.5c6.1-2.9,9.2,4.8,8.8,10.3 C98.7,312,96.8,315.5,91.3,314.8z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "ORNAMENT_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_170_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_79_",
    fill: "#FEC272",
    points: "154.2,215.6 106.6,177.7 98,193.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_80_",
    fill: "#FEC272",
    points: "156.5,204.9 110.3,159.8 127.6,148.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_81_",
    fill: "#FEC272",
    points: "149.7,150.2 165.9,200.6 164.3,148.7  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIllustration);
export default __webpack_public_path__ + "static/media/ErrorIllustration.d5e76db712e8e89fb6251ef046f75c9e.svg";
export { ForwardRef as ReactComponent };